import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { TruthSection } from './components/TruthSection';
import { PainSection } from './components/PainSection';
import { DreamOutcome } from './components/DreamOutcome';
import { WhyMethodsFail } from './components/WhyMethodsFail';
import { SystemIntro } from './components/SystemIntro';
import { ModulesBreakdown } from './components/ModulesBreakdown';
import { BenefitsSection } from './components/BenefitsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-950 font-sans text-slate-300 selection:bg-gold-500/30 selection:text-gold-200" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <TruthSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <DreamOutcome data-id="element-5" />
      <WhyMethodsFail data-id="element-6" />
      <SystemIntro data-id="element-7" />
      <ModulesBreakdown data-id="element-8" />
      <BenefitsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}